//import project images

import BarveCover from "./assets/img/projects/barve.jpg";
import DreamLandCover from "./assets/img/projects/hoteldreamland.jpg";
import LakeViewCover from "./assets/img/projects/lakeview.jpg";
import RunwalCover from "./assets/img/projects//runwal.jpg";
import TatheCover from "./assets/img/projects/tathe.jpg";
import PunePolymersCover from "./assets/img/projects/punepolymers.png";
import NiproCover from "./assets/img/projects/nipro.jpg";
import WorldOfTitanCover from "./assets/img/projects/worldoftitan.png";
import KutwalFoodsCover from "./assets/img/projects/kutwalfoods.png";
import ClubOfficeCover from "./assets/img/projects/cluboffice.png";
import DinaHotelCover from "./assets/img/projects/dinahotel.jpg";
import GV7SalesOfficeCover from "./assets/img/projects/gv7salesoffice.jpg";

export const projects = {
  title: "Projects",
  subtitle:
    "Our commitment lies in delivering projects tailored exclusively to your needs. Each project we undertake is meticulously crafted, drawing from the world's finest resources renowned for their unparalleled quality. Your satisfaction is our priority, ensuring every project exceeds expectations.",
  pages: [
    {
      projectsList: [
        {
          image: <DreamLandCover />,
          name: "Hotel Dreamland",
          place: "Mahabaleshwar",
        },
        {
          image: <TatheCover />,
          name: "Mr. Tathe Bunglow",
          place: "Katraj, Pune",
        },
        {
          image: <RunwalCover />,
          name: "Song of Life County",
          place: "Pirangut, Pune",
        },
        {
          image: <BarveCover />,
          name: "Mr. Barve 3BHK",
          place: "Kothrud, Pune",
        },
      ],
    },
    {
      projectsList: [
        {
          image: <DinaHotelCover />,
          name: "Dina Hotel",
          place: "Mahabaleshwar",
        },
        {
          image: <GV7SalesOfficeCover />,
          name: "GV7 Sales Office",
          place: "Ambegaon Bk, Pune",
        },
        {
          image: <NiproCover />,
          name: "Nipro India Corporation",
          place: "Khandala, Satara",
        },
        {
          image: <KutwalFoodsCover />,
          name: "Kutwal Foods - Urja",
          place: "Shirur, Pune",
        },
      ],
    },
    {
      projectsList: [
        {
          image: <PunePolymersCover />,
          name: "Pune Polymers Pvt. Ltd.",
          place: "Chakan, Pune",
        },
        {
          image: <WorldOfTitanCover />,
          name: "World of Titan",
          place: "Chinchwad, Pune",
        },
        {
          image: <ClubOfficeCover />,
          name: "The Club Offices",
          place: "Shivajinagar, Pune",
        },

        {
          image: <LakeViewCover />,
          name: "Hotel Lake View",
          place: "Mahabaleshwar",
        },
      ],
    },
  ],
};
